import { Input } from 'antd';
import PropTypes from 'prop-types';
import React from 'react';
import { injectIntl, intlShape } from 'react-intl';
import { emptyFn } from 'utils/common';

const defaultProps = {
  isEditing: false,
  onBlur: emptyFn,
  onChange: emptyFn,
  title: ''
};
const propTypes = {
  intl: intlShape.isRequired,
  isEditing: PropTypes.bool,
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  title: PropTypes.string
};

const Title = ({ intl, isEditing, onBlur, onChange, title }) => {
  if (isEditing) {
    return (
      <Input
        value={title}
        onChange={e => onChange(e.target.value)}
        size="small"
        placeholder={intl.formatMessage({
          id: 'page.EditableTitle.inputPlaceholder'
        })}
        onBlur={onBlur}
        autoFocus
      />
    );
  }
  return title ? (
    title
  ) : (
    <span style={{ color: '#ccc' }}>
      {intl.formatMessage({ id: 'page.EditableTitle.placeholder' })}
    </span>
  );
};

Title.defaultProps = defaultProps;
Title.propTypes = propTypes;
export default injectIntl(Title);



// WEBPACK FOOTER //
// ./src/views/DashboardSettings_Slot/components/EditableTitle/components/Title.jsx